export const FONTS = {
  Roboto: '"Roboto", "Helvetica", "Arial", sans-serif',
  RobotoSlab: '"Roboto Slab", "Helvetica", "Arial", sans-serif',
  DMSans: '"DM Sans", "Helvetica", "Arial", sans-serif',
};
